import React, { useState } from "react";
import PropTypes from "prop-types";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { FormMenu } from "../../../components/Buttons";
import ItemListManager from "../../../components/ItemListManager";
import UserDeviceForm from "./UserDeviceForm";
import {
  toUIDate,
  STATUS_LABELS,
  TableEmptyMessage,
  CoverText,
} from "../../../components/Utils";
import TablePageReport from "../../../components/TablePageReport";

const UserDeviceListPanel = (props) => {
  const { className, model, rows } = props;
  const [first, setFirst] = useState(0);

  const onPage = (event) => {
    setFirst(event.first);
  };

  const renderItemTable = (items) => {
    if (items.length === 0) {
      return (
        <CoverText>
          {"Ihnen wurden noch keine Mesgeräte zugewiesen"}
        </CoverText>
      );
    }
    const data = items.map((item) => {
      const copy = JSON.parse(JSON.stringify(item));
      const userNames = `${item.userPrimary}`.split(",");
      let user = "";
      if (userNames.length === 2) {
        user = `${userNames[1]} ${userNames[0]}`;
      }
      return {
        ...copy,
        user,
        nextCheckDateStr: toUIDate(copy.nextCheckDate),
        status: item.status || STATUS_LABELS[item.status_id] || "",
      };
    });
    return (
      <DataTable
        value={data}
        rows={rows}
        paginator={data.length > rows}
        first={first}
        onPage={onPage}
        paginatorLeft={
          <TablePageReport
            className="pad-lft"
            totalRecords={data.length}
            filteredRecords={data.length}
            first={first}
            rows={rows}
            emptyText="Keine Messgeräte"
            itemName="Messgerät"
            itemNamePlural="Messgeräte"
          />
        }
        emptyMessage={<TableEmptyMessage itemNamePlural="Messgeräte" min />}
      >
        <Column
          field="device"
          header="Messgerät"
          sortable={data.length > 1}
          filter={data.length > rows}
          filterMatchMode="contains"
        />
        <Column
          field="serialNumber"
          header="Seriennummer"
          sortable={data.length > 1}
          filter={data.length > rows}
          filterMatchMode="contains"
        />
        <Column
          field="user"
          header="Nutzer"
          sortable={data.length > 1}
          filter={data.length > rows}
          filterMatchMode="contains"
        />
        <Column
          field="nextCheckDateStr"
          header="Prüfung fällig"
          sortable={data.length > 1}
          filter={data.length > rows}
          filterMatchMode="contains"
        />
        <Column
          field="status"
          header="Status"
          sortable={data.length > 1}
          filter={data.length > rows}
          filterMatchMode="contains"
        />
      </DataTable>
    );
  };

  const renderItemForm = (item, onHide) => {
    const userDevice = item;
    return (
      <div>
        <UserDeviceForm model={userDevice} readonly />
        <FormMenu
          className="margin-big-top w3-border-top pad-big"
          style={{
            marginLeft: "-1em",
            marginRight: "-1em",
            marginBottom: "-1em",
          }}
          onCancel={onHide}
          saveDisabled
          saveBtnName="saveUserDeviceBtn"
        />
      </div>
    );
  };

  const getItemFormTitle = () => {
    return <h3 className="no-margin">{`Messgerät ansehen`}</h3>;
  };

  return (
    <ItemListManager
      className={className}
      title={<h3 className="no-margin-top">Messgeräte</h3>}
      addBtnHidden
      items={model}
      getItemFormTitle={getItemFormTitle}
      renderItemTable={renderItemTable}
      renderItemForm={renderItemForm}
      namePrefix="userDevice"
    />
  );
};

UserDeviceListPanel.propTypes = {
  className: PropTypes.string,
  model: PropTypes.array,
  rows: PropTypes.number,
};

UserDeviceListPanel.defaultProps = {
  className: "",
  model: [],
  rows: 10,
};

export default UserDeviceListPanel;
